import { JurisdictionIdNumbersForm } from '@src/clients/JurisdictionIdNumberForm';
import type { CollapseListener } from '@src/orders/CollapseListener';
import { EditOrderCollapsible } from '@src/orders/EditOrderCollapsible';
import type { FormEntries } from '@src/orders/FormEntries';
import { useSectionError } from '@src/orders/hooks/useSectionError';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Props = { fields: string[] } & CollapseListener;

export const JurisdictionIdsSection = (props: Props) => {
  const { t } = useTranslation();
  const { control } = useFormContext<FormEntries<typeof props.fields>>();
  const { sectionInError } = useSectionError(props.fields);

  if (props.fields.length <= 0) {
    return null;
  }

  return (
    <EditOrderCollapsible
      title={t('juridictionIds')}
      id="jurisdiction-ids"
      collapseEventName={props.collapseEventName}
      uncollapseEventName={props.uncollapseEventName}
      inError={sectionInError}
    >
      <JurisdictionIdNumbersForm control={control} fields={props.fields} />
    </EditOrderCollapsible>
  );
};
